import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useCurrentPractice } from '../contexts/PracticeContext'
import { isAdminUser, isScratchAdminUser, isStaff } from '../util/user'
import { selectContext } from '../selectors/auth'

/**
 * Hook to determine if the current staff user is restricted to payment collection only.
 */
export const useStaffPaymentsOnly = (): { restrictStaffToPaymentsOnly: boolean } => {
	const { currentPracticeObject, currentConsolidator } = useCurrentPractice()
	const context: Context = useSelector(selectContext)
	const currentUser = context?.user as any

	const restrictStaffToPaymentsOnly = useMemo(() => {
		if (!currentUser?.practices || !currentPracticeObject?.id) {
			return false
		}

		if (isScratchAdminUser(currentUser) || isAdminUser(currentUser)) {
			return false
		}

		if (isStaff(currentUser, currentPracticeObject?.id as string)) {
			return (
				(currentPracticeObject?.settings?.restrictStaffToPaymentsOnly ??
					currentConsolidator?.featureFlags?.restrictStaffToPaymentsOnly) === true
			)
		}

		return false
	}, [currentPracticeObject, currentConsolidator, currentUser])

	return { restrictStaffToPaymentsOnly }
}
